import { NgModule, provideAppInitializer } from '@angular/core';
import { registerAwningConfigurations } from '@icc/awning/types';

export function registerAwningConfigurator() {
    return () => {
        registerAwningConfigurations();
    };
}
import { CommonModule } from '@angular/common';
import { AwningSystemsComponent } from './awning-systems/awning-systems.component';
// tslint:disable-next-line: nx-enforce-module-boundaries
import { SharedModule } from '@icc/configurator/shared';
import { AwningDimensionsComponent } from './awning-dimensions/awning-dimensions.component';
import { AwningColorsComponent } from './awning-colors/awning-colors.component';
import { AwningSheathingComponent } from './awning-sheathing/awning-sheathing.component';
import { AwningFrillComponent } from './awning-frill/awning-frill.component';
import { AwningAssemblyComponent } from './awning-assembly/awning-assembly.component';
import { SystemsService } from './systems.service';
import { DimensionsService } from './dimensions.service';
import { AssemblyService } from './assembly.service';
import { ColorsService } from './colors.service';
import { SheathingService } from './sheathing.service';
import { FrillService } from './frill.service';
import { DriveService } from './drive.service';
import { ReactiveFormsModule } from '@angular/forms';
import { AwningSystemsInfoComponent } from './awning-systems-info/awning-systems-info.component';
import { AwningDriveComponent } from './awning-drive/awning-drive.component';
import { AwningAccessoriesComponent } from './awning-accessories/awning-accessories.component';
import { AccessoryService } from './accessory.service';
import { AwningAddAccessoriesComponent } from './awning-add-accessories/awning-add-accessories.component';
import { AwningAccessoriesInfoComponent } from './awning-accessories-info/awning-accessories-info.component';
import { ConfiguratorUiModule } from '@icc/configurator/ui';
import { ConfiguratorPagesModule } from '@icc/configurator/pages';
import { AwningStylesPageComponent } from './awning-styles-page/awning-styles-page.component';
import { AwningPriceModule } from './+price';

@NgModule({
    imports: [CommonModule, SharedModule, ReactiveFormsModule, ConfiguratorUiModule, ConfiguratorPagesModule, AwningPriceModule],
    declarations: [
        AwningDimensionsComponent,
        AwningColorsComponent,
        AwningSheathingComponent,
        AwningFrillComponent,
        AwningAssemblyComponent,
        AwningSystemsComponent,
        AwningSystemsInfoComponent,
        AwningDriveComponent,
        AwningAccessoriesComponent,
        AwningAddAccessoriesComponent,
        AwningAccessoriesInfoComponent,
        AwningStylesPageComponent,
    ],
    exports: [
        AwningDimensionsComponent,
        AwningColorsComponent,
        AwningSheathingComponent,
        AwningFrillComponent,
        AwningAssemblyComponent,
        AwningSystemsComponent,
        AwningSystemsInfoComponent,
        AwningDriveComponent,
        AwningAccessoriesComponent,
        AwningAddAccessoriesComponent,
        AwningAccessoriesInfoComponent,
        AwningStylesPageComponent,
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = (registerAwningConfigurator)();
            return initializerFn();
        }),
        SystemsService,
        DimensionsService,
        AssemblyService,
        ColorsService,
        SheathingService,
        FrillService,
        DriveService,
        AccessoryService
    ]
})
export class AwningConfiguratorModule {}
